<template>
  <v-dialog
    v-model="internalValue"
    max-width="900px"
    :fullscreen="isMobile"
    :persistent="false"
    content-class="lang-currency-dialog"
  >
    <v-card>
      <v-card-title
        class="d-flex align-center px-6 pt-6 pb-0 position-relative"
        style="border-bottom: none"
      >
        <v-tabs
          v-model="tab"
          background-color="transparent"
          grow
          :class="{ 'hide-arrows': isMobile }"
          slider-color="primary"
          class="lang-currency-tabs"
        >
          <v-tab class="tab-label" href="#currency">{{ $t("currency") }}</v-tab>
          <v-tab class="tab-label" href="#language">{{ $t("language") }}</v-tab>
        </v-tabs>
        <v-spacer />
        <v-btn icon @click="close" class="close-btn-absolute">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-tabs-items v-model="tab">
        <!-- Language Tab -->
        <v-tab-item value="language">
          <v-card-text class="px-6 pt-6 pb-0">
            <div class="mb-6 text-h6 font-weight-bold">
              {{ $t("choose_language_and_region") }}
            </div>
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'en' }"
                  @click="selectLanguage('en')"
                >
                  <div class="option-title">English</div>
                  <div class="option-subtitle">{{ $t("united_states") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'es' }"
                  @click="selectLanguage('es')"
                >
                  <div class="option-title">Español</div>
                  <div class="option-subtitle">{{ $t("spain") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'he' }"
                  @click="selectLanguage('he')"
                >
                  <div class="option-title">עברית</div>
                  <div class="option-subtitle">{{ $t("israel") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'ru' }"
                  @click="selectLanguage('ru')"
                >
                  <div class="option-title">Русский</div>
                  <div class="option-subtitle">{{ $t("russia") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'it' }"
                  @click="selectLanguage('it')"
                >
                  <div class="option-title">Italiano</div>
                  <div class="option-subtitle">{{ $t("italy") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'de' }"
                  @click="selectLanguage('de')"
                >
                  <div class="option-title">Deutsch</div>
                  <div class="option-subtitle">{{ $t("germany") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'fr' }"
                  @click="selectLanguage('fr')"
                >
                  <div class="option-title">Français</div>
                  <div class="option-subtitle">{{ $t("france") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'ar' }"
                  @click="selectLanguage('ar')"
                >
                  <div class="option-title">العربية</div>
                  <div class="option-subtitle">{{ $t("saudi_arabia") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'zh' }"
                  @click="selectLanguage('zh')"
                >
                  <div class="option-title">中文</div>
                  <div class="option-subtitle">{{ $t("china") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'sv' }"
                  @click="selectLanguage('sv')"
                >
                  <div class="option-title">Svenska</div>
                  <div class="option-subtitle">{{ $t("sweden") }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <div
                  class="option-tile"
                  :class="{ selected: selectedLanguage === 'th' }"
                  @click="selectLanguage('th')"
                >
                  <div class="option-title">ไทย</div>
                  <div class="option-subtitle">{{ $t("thailand") }}</div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
        <!-- Currency Tab -->
        <v-tab-item value="currency">
          <v-card-text class="px-6 pt-6 pb-0">
            <div class="mb-6 text-h6 font-weight-bold">
              {{ $t("choose_currency") }}
            </div>
            <v-row>
              <v-col
                v-for="currency in supportedCurrencies"
                :key="currency.code"
                cols="12"
                sm="6"
                md="4"
              >
                <div
                  class="option-tile mb-0"
                  :class="{
                    selected:
                      currency.code ===
                      (tempSelectedCurrency || selectedCurrency),
                  }"
                  @click="selectCurrency(currency.code)"
                >
                  <div class="option-title">{{ currency.name }}</div>
                  <div class="option-subtitle">
                    {{ currency.code }} – {{ currency.symbol }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import DeviceMixin from "@/mixins/device-mixin";

export default {
  name: "LanguageCurrencyPicker",
  mixins: [DeviceMixin],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    currencies: {
      type: Object,
      required: true,
    },
    selectedLanguage: {
      type: String,
      required: true,
    },
    selectedCurrency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: "currency",
      internalValue: this.value,
      tempSelectedCurrency: null,
      supportedCurrencies: [
        { code: "USD", name: "United States Dollar", symbol: "$" },
        { code: "EUR", name: "Euro", symbol: "€" },
        { code: "ARS", name: "Argentine Peso", symbol: "$" },
        { code: "AUD", name: "Australian Dollar", symbol: "A$" },
        { code: "BRL", name: "Brazilian Real", symbol: "R$" },
        { code: "GBP", name: "British Pound", symbol: "£" },
        { code: "BGN", name: "Bulgarian Lev", symbol: "лв." },
        { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
        { code: "XPF", name: "CFP Franc", symbol: "F" },
        { code: "CLP", name: "Chilean Peso", symbol: "$" },
        { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
        { code: "COP", name: "Colombian Peso", symbol: "$" },
        { code: "CRC", name: "Costa Rican Colon", symbol: "₡" },
        { code: "HRK", name: "Croatian Kuna", symbol: "Kn" },
        { code: "CZK", name: "Czech Republic Koruna", symbol: "Kč" },
        { code: "DKK", name: "Danish Krone", symbol: "Kr" },
        { code: "AED", name: "Emirati Dirham", symbol: "د.إ" },
        { code: "HKD", name: "Hong Kong Dollar", symbol: "$" },
        { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
        { code: "INR", name: "Indian Rupee", symbol: "₹" },
        { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
        { code: "ILS", name: "Israeli New Shekel", symbol: "₪" },
        { code: "JPY", name: "Japanese Yen", symbol: "¥" },
        { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
        { code: "MXN", name: "Mexican Peso", symbol: "Mex$" },
        { code: "MAD", name: "Moroccan Dirham", symbol: "MAD" },
        { code: "TWD", name: "New Taiwan Dollar", symbol: "NT$" },
        { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
        { code: "NOK", name: "Norwegian Krone", symbol: "Kr" },
        { code: "PEN", name: "Peruvian Sol", symbol: "S/" },
        { code: "PHP", name: "Philippine Peso", symbol: "₱" },
        { code: "PLN", name: "Polish Zloty", symbol: "zł" },
        { code: "RON", name: "Romanian Leu", symbol: "Lei" },
        { code: "SAR", name: "Saudi Arabian Riyal", symbol: "ر.س" },
        { code: "SGD", name: "Singapore Dollar", symbol: "$" },
        { code: "ZAR", name: "South African Rand", symbol: "R" },
        { code: "KRW", name: "South Korean Won", symbol: "₩" },
        { code: "SEK", name: "Swedish Krona", symbol: "kr" },
        { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
        { code: "THB", name: "Thai Baht", symbol: "฿" },
        { code: "TRY", name: "Turkish Lira", symbol: "₺" },
        { code: "UYU", name: "Uruguayan Peso", symbol: "$U" },
        { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
      ],
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    selectLanguage(code) {
      this.$i18n.locale = code;
      this.$emit("update:language", code);
      // Close the modal after language selection
      this.close();

      // Force reload to ensure all components update (fallback approach)
      // Uncomment this if navigation approach doesn't work reliably:
      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    selectCurrency(code) {
      this.tempSelectedCurrency = code;
      this.$emit("update:currency", code);
      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    close() {
      this.internalValue = false;
    },
  },
};
</script>

<style scoped lang="scss">
.lang-currency-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  background: #fff;
}
.lang-currency-tabs {
  box-shadow: none !important;
  border-bottom: 1px solid #eee !important;
  min-height: 48px;
  .v-tab {
    min-width: 0;
    text-align: left;
    font-weight: 500;
    font-size: 1.1rem;
    color: #222;
    text-transform: none;
    letter-spacing: 0;
    padding: 0 24px 0 0;
  }
  .v-tabs-bar {
    box-shadow: none !important;
  }
}
.tab-label {
  text-align: left;
  font-size: 1.1rem;
  font-weight: 500;
  color: #222;
  text-transform: none;
  letter-spacing: 0;
}
.close-btn {
  margin-left: 8px;
}
.close-btn-absolute {
  position: absolute !important;
  top: 12px;
  right: 12px;
  z-index: 10;
}

// RTL support for close button
[dir="rtl"] .close-btn {
  margin-left: 0;
  margin-right: 8px;
}

[dir="rtl"] .close-btn-absolute {
  right: auto;
  left: 12px;
}
.option-tile {
  border: 1.5px solid #eee;
  border-radius: 10px;
  padding: 18px 20px 14px 20px;
  margin-bottom: 18px;
  background: #fafbfc;
  cursor: pointer;
  transition: border 0.2s, background 0.2s;
  .option-title {
    font-size: 1.08rem;
    font-weight: 600;
    color: #222;
  }
  .option-subtitle {
    font-size: 0.98rem;
    color: #666;
    margin-top: 2px;
  }
  &.selected {
    border: 2px solid #222;
    background: #f1f3f4;
  }
}
::v-deep .hide-arrows .v-slide-group__prev {
  display: none !important;
}
</style>
